export default "__VITE_ASSET__ab93d5c3__"